import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";

export function NotFound() {
  const navigate = useNavigate();
  return (
    <Layout>
      <section className="max-w-xl mx-auto px-4 py-20 text-center">
        <Compass className="h-12 w-12 mx-auto text-muted-foreground" />
        <p className="text-xs uppercase tracking-widest text-muted-foreground mt-4">404</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1">Lost the path</h1>
        <p className="mt-3 text-muted-foreground">
          That page doesn’t exist. Let’s get you back to the board.
        </p>
        <div className="mt-6 flex flex-wrap gap-2 justify-center">
          <Button className="rounded-full" onClick={() => navigate("/")}>Home</Button>
          <Button variant="outline" className="rounded-full" onClick={() => navigate("/play")}>
            Play
          </Button>
        </div>
      </section>
    </Layout>
  );
}
